import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import constants from "../../assets/constants";
import * as PatientSessionActions from "../../state/redux/patientSession";
import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import DemoPatientSymptoms from "../widgets/demoPatientSymptoms";
import PatientAgenda from "../widgets/patientAgenda";
import PatientAssessments from "../widgets/patientAssessments";
import PatientConditions from "../widgets/patientConditions";
import PatientGoals from "../widgets/patientGoals";
import PatientJournal from "../widgets/patientJournal";
import PatientMedications from "../widgets/patientMedications";
import PatientMotivations from "../widgets/patientMotivations";
import PatientProfile from "../widgets/patientProfile";

const PatientPortal = props => {
  const { patientODM, awsGroup, loadPatientODMRequest } = props;

  useEffect(() => {
    if (patientODM == null) {
      loadPatientODMRequest(constants.demoUserId.userOne);
    }
  }, [patientODM, loadPatientODMRequest]);

  return (
    <Portal>
      <PortalAppBar title="Patient Portal" />
      {patientODM != null && awsGroup === constants.userGroups.Creator && (
        <PortalGridContent>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <PatientProfile
              patientChart={props.patientChart}
              patientODM={patientODM}
              patientImage={props.patientImage}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <PatientAgenda />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <PatientAssessments />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <PatientMotivations />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <DemoPatientSymptoms patientChart={props.patientChart} />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <PatientGoals />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <PatientMedications />
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <PatientConditions />
          </Grid>

          <Grid item xs={12} sm={12}>
            <PatientJournal />
          </Grid>
          <Grid item xs={12}></Grid>
        </PortalGridContent>
      )}
      {patientODM != null && awsGroup !== constants.userGroups.Creator && (
        <PortalGridContent>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
            <PatientAssessments />
          </Grid>
          <Grid item xs={12}></Grid>
        </PortalGridContent>
      )}
    </Portal>
  );
};

const mapStateToProps = state => ({
  patientODM: state.patientSession.patientODM,
  patientAssessments: state.patientSession.patientAssessments,
  bpShowChat: state.userSession.bpShowChat,
  awsGroup: state.userSession.awsGroup,

  //#region REFACTOR and DELETE
  patientChart: state.patientSession.patientChart,
  patientImage: state.patientSession.patientImage,
  //#endregion
});

const mapDispatchToProps = {
  loadPatientODMRequest: PatientSessionActions.loadPatientODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PatientPortal));
